import { Trans } from "react-i18next";
import { useAppSelector } from "../../store/hooks";

function Footer(props: any) {
    const showHerdSelector = useAppSelector((state) => state.app.showHerdSelector);

    return (
        <footer>
            {showHerdSelector && (<Trans i18nKey="Herd.Info" />) }
        </footer>
    );
}

export default Footer;